
import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Input, Radio, Divider } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFlightOffers } from '../../../redux/flight/flightOffersSlice';
import { FaTimes } from 'react-icons/fa';

const FlightOffersTripjack = forwardRef(({
    totalPriceBaggages,
    appliedCheckLogin,
    setAppliedCheckLogin,
    applyDiscount,
    applyDiscountShow,
    setApplyDiscountShow,
    isCongratulations,
    setIsCongratulations,
    isValidCoupon,
    setValidCoupon,
    totalAfterDiscount,
    setErrorMessage,
    errorMessage,
    setDiscountAmountOffer,
    totalBookingPrice,
    selectedCode,
    setSelectedCode
}, ref) => {

    const dispatch = useDispatch();
    const { offers, loading, error } = useSelector((state) => state.flightOffers);

    useEffect(() => {
        dispatch(fetchFlightOffers());
    }, [dispatch]);



    const handleInputChange = (e) => {
        setSelectedCode(e.target.value);
    };

    const handleRemoveCode = () => {
        setSelectedCode("");
        setAppliedCheckLogin(null);
        setApplyDiscountShow(false);
        setIsCongratulations(false);
        setValidCoupon(null);
        setErrorMessage("");
        setDiscountAmountOffer(0);
    };

    useImperativeHandle(ref, () => ({
        handleRemoveCode
    }));

    let getUser = JSON.parse(localStorage.getItem("user"));
    let getTokenId = JSON.parse(localStorage.getItem("tokenId"));
    let totalAmount = totalBookingPrice;

    useEffect(() => {
        if (!appliedCheckLogin) return;
        if (appliedCheckLogin?.is_login === 1 && !getTokenId) {
            dispatch(setModal2Open(true));
        } else if (appliedCheckLogin?.is_login === 1 && getTokenId) {
            applyDiscount();
        } else if (!appliedCheckLogin?.is_login) {
            applyDiscount();
        }
    }, [appliedCheckLogin]);

    useEffect(() => {
        if (selectedCode) {
            const offer = offers.find((offer) => offer.code === selectedCode);
            if (offer) {
                handleRadioChange(selectedCode, offer);
            }
        }
    }, [totalAmount, selectedCode]);

    const handleRadioChange = (code, offer) => {
        setAppliedCheckLogin(offer);
        setSelectedCode(code);
        setApplyDiscountShow(true);
        setIsCongratulations(true);
        setValidCoupon(null);
        setErrorMessage("");
    };


    const filteredOffers = offers
        .filter(offer =>
            totalBookingPrice >= parseFloat(offer.min_order_value) &&
            totalBookingPrice <= parseFloat(offer.max_order_value)
        )
        .sort((a, b) => parseFloat(a.min_order_value) - parseFloat(b.min_order_value));

    return (
        <>
            <div className="card mb-md-5 mb-2">
                <div className="card-header py-2">
                    <h3>Apply Discount</h3>
                    <p className="fw-bold">
                        <small>Have a discount/ promo code to redeem  </small>
                    </p>
                </div>

                <div className="card-body py-2">
                    <div className="d-flex gap-10 mt-1 mb-4">
                        <Input
                            type="text"
                            value={selectedCode}
                            onChange={handleInputChange}
                            placeholder="Promo Code"
                            className="form-control rounded"
                            style={{ height: "40px", padding: "10px", outline: "none" }}
                            suffix={
                                selectedCode && <FaTimes onClick={handleRemoveCode} />
                            }
                        />

                        {applyDiscountShow && (
                            <a
                                className="btn btn-primary menu-block rounded text-center"
                                onClick={handleRemoveCode}
                            >
                                Remove
                            </a>
                        )}
                    </div>
                    {isCongratulations && (
                        <p className="text_grn mb-2">
                            Congratulations coupon code has been applied successfull{" "}
                            {appliedCheckLogin?.description}
                        </p>
                    )}

                    {isValidCoupon && (
                        <p className="text_red mb-2" style={{ color: "red" }}>
                            {isValidCoupon}
                        </p>
                    )}

                    {errorMessage && (
                        <p className="text_red mb-2" style={{ color: "red" }}>
                            {errorMessage}
                        </p>
                    )}



                    <div>
                        {filteredOffers?.map((offer, index) => (
                            <div key={index}>
                                <label className="d-flex align-items-center gap-10">
                                    <span>
                                        <Radio
                                            id={offer?.code}
                                            name="offerradio"
                                            checked={selectedCode === offer?.code}
                                            onChange={() => handleRadioChange(offer?.code, offer)}
                                        />
                                    </span>
                                    <div>
                                        <p>
                                            <b>{offer.code}</b>
                                        </p>
                                        <p className="lh-14">
                                            <small className="fw-bold">{offer?.description}</small>
                                        </p>
                                    </div>
                                </label>
                                {index < offers?.length - 1 && <Divider className="my-3" />}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
});

export default FlightOffersTripjack;
